import { JSResourceForInteraction } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';

export const dashboardDirectoryEntryPoint = createEntryPoint({
	root: JSResourceForInteraction(
		() => import(/* webpackChunkName: "dashboard-directory-entrypoint" */ './src/index.tsx'),
	),
	getPreloadProps: () => {
		return {};
	},
});
